import { render, staticRenderFns } from "./orderDelivery.vue?vue&type=template&id=f37dffac&scoped=true&"
import script from "./orderDelivery.vue?vue&type=script&lang=js&"
export * from "./orderDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37dffac",
  null
  
)

export default component.exports